
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import IntroduceCard from "../components/introduce-card.vue";
import {
  CustomPage,
  ExamVersionInfo
} from "@/lib/model/exambuilder/exam-component/exam";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import HinaSelect from "@/views/ai-builder-component/baseComponent/hina-select.vue";
import HinaTextarea from "@/views/ai-builder-component/baseComponent/hina-textarea.vue";
import HinaInput from "@/views/ai-builder-component/baseComponent/hina-input.vue";
import HinaInputNumber from "@/views/ai-builder-component/baseComponent/hina-input-number.vue";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import HinaUpload from "@/views/ai-builder-component/baseComponent/hina-upload.vue";
import Pop from "@/views/ai-builder-component/components/blue-pop.vue";
import { ElForm } from "element-ui/types/form";
import Editor5 from "@/components/editor/classic-editor5.vue";

@Component({
  components: {
    Editor5,
    Pop,
    HinaUpload,
    HinaRadioGroup,
    HinaInputNumber,
    HinaInput,
    HinaTextarea,
    HinaSelect,
    HinaSwitch,
    IntroduceCard
  }
})
export default class CustomPageCom extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  @Watch("formItemData", { immediate: true, deep: true })
  init(value: ExamVersionInfo) {
    value.customPageConfigList.forEach(item => {
      if (item.sortType !== "question") return;

      item.questionSort = item.componentSort + 1;
    });
  }

  textAlignOptions = [
    { name: "居中", value: 0 },
    { name: "居左", value: 1 }
    // { name: "居右", value: 2 }
  ];

  rules = {
    title: [
      { required: true, message: "请填写标题", trigger: ["change", "blur"] }
    ],
    text: [
      { required: true, message: "请填写内容", trigger: ["change", "blur"] }
    ],
    videoMustPlayText: [
      {
        required: true,
        message: "请填写强制播放提示",
        trigger: ["change", "blur"]
      }
    ],
    buttonText: [
      { required: true, message: "请填写按钮名称", trigger: ["change", "blur"] }
    ],
    videoUrl: [{ required: true, message: "请上传视频", trigger: "change" }],
    videoCoverUrl: [
      { required: true, message: "请上传图片", trigger: "change" }
    ]
  };

  get maxQuestionNumber() {
    return this.formItemData.questionSelectedList.length;
  }

  @Emit("setGlobal")
  setGlobal() {
    return;
  }

  handleChangeShowWay() {
    (this.$refs.formRef as ElForm).clearValidate();
  }

  handleChangeQuestionSort(e: number, item: CustomPage) {
    item.configData.positionType = 5;
    item.questionSort = e;
    item.componentSort = e - 1;
    this.$forceUpdate();
  }

  handleAddPage() {
    const customPage = new CustomPage();
    customPage.use = 1;
    this.formItemData.customPageConfigList.push(customPage);
    console.log(this.formItemData.customPageConfigList);
    this.$forceUpdate();
  }

  // 校验数据
  formItemCheck() {
    return new Promise(resolve => {
      (this.$refs.formRef as ElForm)
        .validate()
        .then(() => resolve(""))
        .catch(() => resolve("customPage"));
    });
  }
}
